<template>
  <div
    class="screening-box-container"
    @click="onClickContainer"
  >
    <transition name="fade">
      <div
        v-if="screeningBoxShowLeft"
        class="screening-mask"
        @click.self="hide"
        @touchmove="onTouchMoveMask"
      ></div>
    </transition>
    <div
      ref="screeningBox"
      class="component-screening-box"
      :class="{'swipe-left':screeningBoxShowLeft,'swipe-right':screeningBoxShowRight}"
      :style="{width:width}"
    >
      <div
        class="content-container"
        :style="{height:height}"
      >
        <ScrollView
          ref="contentScroll"
          class="scroll-view-wrapper tran"
          :bounce="false"
        >
          <div
            ref="screeningContent"
            class="screening-content"
            :style="{width:width,}"
          >
            <ServiceAddressBox
              @onClickDeliveryAddressShow="onClickDeliveryAddressShow"
              :defaultAddress="defaultAddress"
            />
            <TypeSection
              :dataTypeList="dataTypeList"
              :defaultDataTypeObject="defaultDataTypeObject"
              @onClickDefaultDataType="onClickDefaultDataType"
            />

            <FreePeriods
              ref="freePeriods"
              :searchData="searchData"
            />

            <PriceSection
              ref="priceSection"
              :searchData="searchData"
              @onFcousStartPrice="onFcousPrice"
              @onFcousEndPrice="onFcousPrice"
              @onBlurStartPrice="onBlurPrice"
              @onBlurEndPrice="onBlurPrice"
            />

            <CommonSection
              @onClickAllClassifyShow="onClickAllClassifyShow"
              :secondCateList="secondCateList"
              :defaultSecondCate="defaultSecondCate"
              @onClickDefaultSecondCate="onClickDefaultSecondCate"
              v-if="secondCateList.length"
            />

            <ThirdSection
              @onClickThirdClassifyShow="onClickThirdClassifyShow"
              :thirdCateList="thirdCateList"
              :defaultThirdCate="defaultThirdCate"
              @onClickDefaultThirdCate="onClickDefaultThirdCate"
              v-if="thirdCateList.length"
            />

            <BrandSection
              ref="brandSection"
              @onClickAllBrandShow="onClickAllBrandShow"
              :brandCateList="brandCateList"
              :defaultBrandCate="defaultBrandCate"
              @onClickDefaultBrandCate="onClickDefaultBrandCate"
              v-if="brandCateList.length"
            />
          </div>
        </ScrollView>
      </div>

      <div
        ref="screeningContentButtonContainer"
        class="screening-content-button-container jr-x-fixed-bottom-bar-inner"
        v-if="isShowBtn"
      >
        <div
          class="screening-content-button screening-content-reset"
          @click="onClickReset"
          clstag="jr|keycount|jdjr_search_filter|reset"
        >重置</div>
        <div
          class="screening-content-button screening-content-sure"
          @click="onClickConfirm"
          clstag="jr|keycount|jdjr_search_filter|sure"
        >确定</div>
      </div>

      <DeliveryAddress
        :width="width"
        @onDeliveryHeight="onDeliveryHeight"
        :deliveryAddressShow="deliveryAddressShow"
        :deliveryAddressHidden="deliveryAddressHidden"
        :defaultAddress="defaultAddress"
        :address="address"
        @onClickDeliveryAddressHidden="onClickDeliveryAddressHidden"
        @onClickSelectAddressShow="onClickSelectAddressShow"
        onClickDefaultAddress="onClickDefaultAddress"
      />

      <SelectAddress
        ref="selectAddress"
        :width="width"
        :top="`${deliveryHeight}px`"
        :height="selectHeight"
        :selectAddressShow="selectAddressShow"
        :selectAddressHidden="selectAddressHidden"
        @onClickDeliveryAddressHidden="onClickDeliveryAddressHidden"
      />

      <AllClassify
        :width="width"
        :allClassifyShow="allClassifyShow"
        :allClassifyHidden="allClassifyHidden"
        @onClickAllClassifyHidden="onClickAllClassifyHidden"
        :secondCateList="secondCateList"
        :defaultSecondCate="defaultSecondCate"
        @onClickDefaultSecondCate="onClickDefaultSecondCate"
        v-if="secondCateList.length"
      />

      <ThirdClassify
        :width="width"
        :thirdClassifyShow="thirdClassifyShow"
        :thirdClassifyHidden="thirdClassifyHidden"
        @onClickThirdClassifyHidden="onClickThirdClassifyHidden"
        :thirdCateList="thirdCateList"
        :defaultThirdCate="defaultThirdCate"
        @onClickDefaultThirdCate="onClickDefaultThirdCate"
        v-if="thirdCateList.length"
      />

      <AllBrand
        :width="width"
        :allBrandShow="allBrandShow"
        :allBrandHidden="allBrandHidden"
        @onClickAllBrandHidden="onClickAllBrandHidden"
        :brandCateList="brandCateList"
        :defaultBrandCate="defaultBrandCate"
        @onClickDefaultBrandCate="onClickDefaultBrandCate"
        v-if="brandCateList.length>2"
      />
      <div
        class="div-none"
        ref="divNone"
      ></div>
    </div>
  </div>
</template>

<script>
import ServiceAddressBox from '@/buscomponents/search/ServiceAddressBox.vue';
import FreePeriods from '@/buscomponents/search/FreePeriods.vue';
import PriceSection from '@/buscomponents/search/PriceSection.vue';
import TypeSection from '@/buscomponents/search/TypeSection.vue';
import CommonSection from '@/buscomponents/search/CommonSection.vue';
import ThirdSection from '@/buscomponents/search/ThirdSection.vue';

import BrandSection from '@/buscomponents/search/BrandSection.vue';
import DeliveryAddress from '@/buscomponents/search/DeliveryAddress.vue';
import AllClassify from '@/buscomponents/search/AllClassify.vue';
import ThirdClassify from '@/buscomponents/search/ThirdClassify.vue';
import AllBrand from '@/buscomponents/search/AllBrand.vue';
import SelectAddress from '@/buscomponents/search/SelectAddress.vue';
import ScrollView from '@/components/ScrollView.vue';
import request from '@/util/request';
export default {
  name: 'ScreeningBox',
  components: {
    ServiceAddressBox,
    FreePeriods,
    PriceSection,
    DeliveryAddress,
    AllClassify,
    ThirdClassify,
    AllBrand,
    TypeSection,
    SelectAddress,
    CommonSection,
    ThirdSection,
    BrandSection,
    ScrollView
  },
  data() {
    return {
      isShowBtn: true,
      left: '',
      width: '100%',
      height: '100%',
      deliveryHeight: '',
      selectHeight: '',
      isShow: false,
      screeningBoxShowLeft: false,
      screeningBoxShowRight: false,
      deliveryAddressShow: false,
      deliveryAddressHidden: false,
      selectAddressShow: false,
      selectAddressHidden: false,
      allClassifyShow: false,
      allClassifyHidden: false,
      thirdClassifyShow: false,
      thirdClassifyHidden: false,
      allBrandShow: false,
      allBrandHidden: false,
      address: [],
      defaultAddress: {}, //默认选中地址初始化地址为空对象
      fullAddress: '',
      dataTypeList: [
        {
          name: '京东自营',
          dataType: 'Y',
          clstag: 'jr|keycount|jdjr_search_goodstype|jingdongziying'
        },
        {
          name: '商家运营',
          dataType: 'N',
          clstag: 'jr|keycount|jdjr_search_goodstype|shangjiayunying'
        }
      ],
      defaultDataType: '',
      defaultDataTypeObject: {},
      secondCateList: [
        // {
        //   itemSecondCateName: '',
        //   itemSecondCateCd: ''
        // },
        // {
        //   itemSecondCateName: '',
        //   itemSecondCateCd: ''
        // }
      ],
      thirdCateList: [
        // {
        //   itemSecondCateName: '',
        //   itemSecondCateCd: ''
        // },
        // {
        //   itemSecondCateName: '',
        //   itemSecondCateCd: ''
        // }
      ],
      defaultItemSecondCateCd: '',
      defaultSecondCate: {},

      defaultItemThirdCateCd: '',
      defaultThirdCate: {},
      brandCateList: [
        // {
        //   barndNameCn: '',
        //   brandCode: ''
        // },
        // {
        //   barndNameCn: '',
        //   brandCode: ''
        // }
      ],
      defaultBrandCode: '',
      defaultBrandCate: [],
      // 省级编号
      provinceId: '',
      // 市级编号
      cityId: '',
      // 县级编号
      countyId: '',
      // 镇级编号
      townId: ''
    };
  },
  props: {
    searchData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    matchFirstCtgyCds() {
      return (this.searchData && this.searchData.matchFirstCtgyCds && this.searchData.matchFirstCtgyCds.toString()) || '';
    },
    matchSecondCtgyCds() {
      return (this.searchData && this.searchData.matchSecondCtgyCds && this.searchData.matchSecondCtgyCds.toString()) || '';
    },
    matchThirdCtgyCds() {
      return (this.searchData && this.searchData.matchThirdCtgyCds && this.searchData.matchThirdCtgyCds.toString()) || '';
    }
  },
  created() {
    this.update();
  },
  methods: {
    onTouchMoveMask(e) {
      e.preventDefault();
    },
    onClickContainer() {
      setTimeout(() => {
        $('input').blur();
      }, 100);
    },
    onFcousPrice() {
      console.log('onFcousPrice');
      if ($ && $.device && $.device.android) {
        this.isShowBtn = false;

        if (this.$refs && this.$refs.contentScroll) {
          this.$refs.contentScroll.scrollToElement(this.$refs.priceSection.$el, 1);
        }
      }
    },
    onBlurPrice() {
      console.log('onBlurPrice');
      if ($ && $.device && $.device.android) {
        this.isShowBtn = true;
      }
    },
    show() {
      this.screeningBoxShowLeft = true;
      this.screeningBoxShowRight = false;
      if (JSON.stringify(this.defaultAddress) === '{}') {
        this.getAddress();
      }
      if (this.matchThirdCtgyCds !== '') {
        this.getBrandCateByThirdCateSearch(this.matchThirdCtgyCds);
      }
      if (this.matchThirdCtgyCds === '' && this.matchSecondCtgyCds !== '') {
        if (this.thirdCateList.length === 0) {
          this.getThirdCateSearch(this.matchSecondCtgyCds); //通过二级查三级类目
          if (this.defaultItemThirdCateCd != '') {
            //选中三级类目
            this.getBrandCateByThirdCateSearch(this.defaultItemThirdCateCd);
          } else {
            this.getBrandCateBySecondCateSearch(this.matchSecondCtgyCds); //通过二级查品牌
          }
        }
      }

      if (this.matchThirdCtgyCds === '' && this.matchSecondCtgyCds === '' && this.matchFirstCtgyCds !== '') {
        if (this.secondCateList.length === 0) {
          this.getSecondCateSearch(this.matchFirstCtgyCds);
          this.getBrandCateBySecondCateSearch(this.defaultItemSecondCateCd);
        }
      }

      this.$emit('showed');
    },
    hide() {
      this.screeningBoxShowLeft = false;
      this.screeningBoxShowRight = true;

      this.$emit('hided');
    },
    update() {
      let _secondCateList = this.searchData.secondCateList || '';
      this.defaultItemSecondCateCd = _secondCateList; //默认选中二级类目

      let _thirdCateList = this.searchData.thirdCateList || '';
      this.defaultItemThirdCateCd = _thirdCateList; //默认选中三级类目

      let _brandCateList = this.searchData.brandCateList || '';
      this.defaultBrandCode = _brandCateList; //默认选中品牌

      let _dataType = this.searchData.dataType || '';
      this.defaultDataType = _dataType;
      this.defaultDataTypeObject = this.filterDefaultDataType(this.dataTypeList, this.defaultDataType);
      let _provinceId = this.searchData.provinceId || '';
      this.provinceId = _provinceId;
      let _cityId = this.searchData.cityId || '';
      this.cityId = _cityId;
      let _countyId = this.searchData.countyId || '';
      this.countyId = _countyId;
      let _townId = this.searchData.townId || '';
      this.townId = _townId;
      let _fullAddress = this.searchData.fullAddress || '';
      this.fullAddress = _fullAddress;
    },
    showScreeningContentWidth() {
      const left = $(this.$refs.divNone).width();
      // const height = $(this.$refs.screeningContentButtonContainer).height(); //button
      // console.log($(this.$refs.screeningContentButtonContainer).position().top);
      this.left = `${left}px`;
      this.width = `${$(document).width() - left}px`;
      //this.height = `${$(document).height() - height}px`;
      this.height = `${$(this.$refs.screeningContentButtonContainer).position().top}px`;
      this.selectHeight = $(this.$refs.screeningBox).height() - this.deliveryHeight;
    },

    onClickDeliveryAddressShow() {
      if (this.address.length !== 0) {
        this.deliveryAddressShow = true;
        this.deliveryAddressHidden = false;
      } else {
        this.deliveryAddressShow = true;
        this.deliveryAddressHidden = false;
        this.selectAddressShow = true;
        this.selectAddressHidden = false;
        this.$refs.selectAddress.getData();
      }
    },
    onClickDeliveryAddressHidden(value) {
      this.deliveryAddressShow = false;
      this.deliveryAddressHidden = true;
      this.selectAddressShow = false;
      this.selectAddressHidden = true;
      if (value) {
        this.fullAddress = '';
        value.forEach(element => {
          this.fullAddress += element.name;
        });
        this.defaultAddress = {
          fullAddress: this.fullAddress
        };
        if (value && value.length == 3) {
          this.provinceId = value[0].id;
          this.cityId = value[1].id;
          this.countyId = value[2].id;
          this.townId = '';
        } else if (value && value.length == 4) {
          this.provinceId = value[0].id;
          this.cityId = value[1].id;
          this.countyId = value[2].id;
          this.townId = value[3].id;
        }
      }
    },
    onClickAllClassifyShow() {
      this.allClassifyShow = true;
      this.allClassifyHidden = false;
    },
    onClickAllClassifyHidden() {
      this.allClassifyShow = false;
      this.allClassifyHidden = true;
    },
    onClickThirdClassifyShow() {
      this.thirdClassifyShow = true;
      this.thirdClassifyHidden = false;
    },
    onClickThirdClassifyHidden() {
      this.thirdClassifyShow = false;
      this.thirdClassifyHidden = true;
    },
    onClickAllBrandShow() {
      this.allBrandShow = true;
      this.allBrandHidden = false;
    },
    onClickAllBrandHidden() {
      this.allBrandShow = false;
      this.allBrandHidden = true;
    },
    onClickSelectAddressShow() {
      this.selectAddressShow = true;
      this.selectAddressHidden = false;
      if (this.address.length !== 0) {
        this.$refs.selectAddress.getData();
      }
    },

    onDeliveryHeight(value) {
      this.deliveryHeight = value;
    },
    onClickDefaultAddress(value) {
      this.defaultAddress = value;
      this.fullAddress = this.defaultAddress.fullAddress;
      this.provinceId = this.defaultAddress.provinceId;
      this.cityId = this.defaultAddress.cityId;
      this.countyId = this.defaultAddress.countyId;
      this.townId = this.defaultAddress.townId;
      this.address.map(item => {
        item.selected = false;
      });
      value.selected = true;
    },

    onClickDefaultSecondCate(value) {
      if (value.itemSecondCateCd !== this.defaultItemSecondCateCd) {
        this.defaultSecondCate = value;
        this.defaultItemSecondCateCd = this.defaultSecondCate.itemSecondCateCd;
        this.defaultBrandCate = [];
        this.defaultBrandCode = '';
        this.getBrandCateBySecondCateSearch(value.itemSecondCateCd);
      } else {
        this.defaultSecondCate = {};
        this.defaultItemSecondCateCd = '';
        this.defaultBrandCate = [];
        this.defaultBrandCode = '';
        this.brandCateList = []; //品牌为空
      }
    },
    //
    onClickDefaultThirdCate(value) {
      if (value.itemThirdCateCd !== this.defaultItemThirdCateCd) {
        this.defaultThirdCate = value;
        this.defaultItemThirdCateCd = this.defaultThirdCate.itemThirdCateCd;
        this.defaultBrandCate = [];
        this.defaultBrandCode = '';
        this.getBrandCateByThirdCateSearch(value.itemThirdCateCd);
      } else {
        this.defaultThirdCate = {};
        this.defaultItemThirdCateCd = '';
        this.defaultBrandCate = [];
        this.defaultBrandCode = '';
        this.getBrandCateBySecondCateSearch(this.matchSecondCtgyCds);
      }
    },

    onClickDefaultDataType(value) {
      this.defaultDataTypeObject = value;
      this.defaultDataType = this.defaultDataTypeObject.dataType;
    },
    onClickDefaultBrandCate(value) {
      if (this.$refs.brandSection.everyFilter(this.defaultBrandCate, value)) {
        this.defaultBrandCate = this.defaultBrandCate.filter(function(item) {
          return item.brandCode !== value.brandCode;
        });
      } else {
        if (this.defaultBrandCate.length <= 6) {
          this.defaultBrandCate.push(value);
        } else {
          //this.$alert.show({ content: '品牌最多选7个' });
        }
      }

      let _defaultBrandCode = this.defaultBrandCate
        .map(function(item) {
          return item.brandCode;
        })
        .toString();
      this.defaultBrandCode = _defaultBrandCode;
    },

    onClickConfirm() {
      const rst = {};
      if (this.$refs) {
        if (this.$refs.freePeriods) {
          this.$refs.freePeriods.periods.map(item => {
            rst[item.key] = item.selected ? '1' : '0';
          });
        }

        if (this.$refs.priceSection) {
          rst.startPrice = this.$refs.priceSection.startPrice;
          rst.endPrice = this.$refs.priceSection.endPrice;

          if (rst.startPrice > rst.endPrice) {
            const temp = rst.startPrice;
            rst.startPrice = rst.endPrice;
            rst.endPrice = temp;
          }
        }
        rst.secondCateList = this.defaultItemSecondCateCd;
        rst.thirdCateList = this.defaultItemThirdCateCd;

        rst.brandCateList = this.defaultBrandCode;
        rst.provinceId = this.provinceId;
        rst.cityId = this.cityId;
        rst.countyId = this.countyId;
        rst.townId = this.townId;
        rst.fullAddress = this.fullAddress;
        rst.dataType = this.defaultDataType;
      }

      this.$emit('onClickScreeningBox', rst);
    },
    onClickReset() {
      this.defaultItemSecondCateCd = '';
      this.defaultSecondCate = {};
      this.defaultItemThirdCateCd = '';
      this.defaultThirdCate = {};

      this.defaultBrandCate = [];
      this.defaultBrandCode = '';
      this.getBrandCateBySecondCateSearch(this.matchSecondCtgyCds);
      this.defaultDataType = '';
      this.defaultDataTypeObject = {};
      this.$refs.freePeriods.onClickReset();
      this.$refs.priceSection.onClickReset();
    },
    filterDefaultDataType(array, value) {
      return (
        array.filter(function(item) {
          if (item && item.dataType && value) {
            return item.dataType == value;
          }
        })[0] || {}
      );
    },

    filterDefaultSecondCate(array, value) {
      return (
        array.filter(function(item) {
          if (item && item.itemSecondCateCd && value) {
            return item.itemSecondCateCd == value;
          }
        })[0] || {}
      );
    },
    filterDefaultThirdCate(array, value) {
      return (
        array.filter(function(item) {
          if (item && item.itemThirdCateCd && value) {
            return item.itemThirdCateCd == value;
          }
        })[0] || {}
      );
    },
    filterDefaultAddress(data, provinceId, cityId, countyId, townId, fullAddress) {
      return (
        data.filter(function(item) {
          if (item) {
            return item.provinceId == provinceId && item.cityId == cityId && item.countyId == countyId && item.townId == townId && item.fullAddress == fullAddress;
          }
        })[0] || { fullAddress: this.searchData.fullAddress }
      );
    },
    someDefaultAddress(data, provinceId, cityId, countyId, townId, fullAddress) {
      data.some(item => {
        if (item.provinceId == provinceId && item.cityId == cityId && item.countyId == countyId && item.townId == townId && item.fullAddress == fullAddress) {
          return (item.selected = true);
        }
      });
    },
    //获取地址接口
    getAddress() {
      this.$loading.show();
      request.getAddress({
        // 参数
        data: {},
        // 成功
        success: data => {
          console.log(data);
          this.$loading.hide();
          if (data && data.address && data.addressList) {
            this.address = data.addressList;

            if (this.provinceId === '' && this.cityId === '' && this.countyId === '' && this.townId === '') {
              this.fullAddress = data.address.fullAddress;
              this.defaultAddress = data.address;
              this.provinceId = this.defaultAddress.provinceId;
              this.cityId = this.defaultAddress.cityId;
              this.countyId = this.defaultAddress.countyId;
              this.townId = this.defaultAddress.townId;
            } else {
              this.defaultAddress = this.filterDefaultAddress(data.addressList, this.provinceId, this.cityId, this.countyId, this.townId, this.fullAddress);
            }
            this.someDefaultAddress(this.address, this.provinceId, this.cityId, this.countyId, this.townId, this.fullAddress);
          } else if (data && data.address && !data.addressLis) {
            //无默认收货地址
            if (this.provinceId === '' && this.cityId === '' && this.countyId === '' && this.townId === '') {
              this.defaultAddress = {
                fullAddress: '选择配送地址'
              };
              this.provinceId = data.address.provinceId;
              this.cityId = data.address.cityId;
              this.countyId = data.address.countyId;
              this.townId = data.address.townId;
              this.fullAddress = '选择配送地址';
            } else {
              this.defaultAddress = { fullAddress: this.searchData.fullAddress };
            }
          }
        },
        // 接口失败
        afterError: () => {
          this.$loading.hide();
        }
      });
    },
    //二级类目搜索接口
    getSecondCateSearch(item) {
      this.$loading.show();
      request.getSecondCateSearch({
        // 参数
        data: {
          itemFirstCateCd: item
        },
        // 成功
        success: data => {
          console.log(data);
          if (data && data.secondCateList) {
            this.$loading.hide();
            this.secondCateList = data.secondCateList;
            this.defaultSecondCate = this.filterDefaultSecondCate(this.secondCateList, this.defaultItemSecondCateCd);
          }
        },
        // 接口失败
        afterError: () => {
          this.$loading.hide();
        }
      });
    },
    getThirdCateSearch(item) {
      this.$loading.show();
      request.getThirdCateSearch({
        // 参数
        data: {
          itemSecondCateCd: item
        },
        // 成功
        success: data => {
          console.log(data);
          if (data && data.thirdCateList) {
            this.$loading.hide();
            this.thirdCateList = data.thirdCateList;
            this.defaultThirdCate = this.filterDefaultThirdCate(this.thirdCateList, this.defaultItemThirdCateCd);
          }
        },
        // 接口失败
        afterError: () => {
          this.$loading.hide();
        }
      });
    },
    //品牌类目搜索接口
    getBrandCateBySecondCateSearch(item) {
      this.$loading.show();
      request.getBrandCateBySecondCateSearch({
        // 参数
        data: { itemSecondCateCd: item },
        // 成功
        success: data => {
          console.log(data);
          this.$loading.hide();
          if (data && data.brandCateList) {
            //this.brandCateList = data.brandCateList;
            this.brandCateList = this.filterBrand(data.brandCateList); //过滤
            let str = ',' + this.defaultBrandCode + ',';
            this.defaultBrandCate = this.brandCateList.filter(items => {
              return str.indexOf(',' + items.brandCode + ',') !== -1;
            });
          }
        },
        // 接口失败
        afterError: () => {
          this.$loading.hide();
        }
      });
    },

    getBrandCateByThirdCateSearch(item) {
      this.$loading.show();
      request.getBrandCateByThirdCateSearch({
        // 参数
        data: { itemThirdCateCd: item },
        // 成功
        success: data => {
          console.log(data);
          this.$loading.hide();
          if (data && data.brandCateList) {
            //this.brandCateList = data.brandCateList;
            this.brandCateList = this.filterBrand(data.brandCateList); //过滤

            let str = ',' + this.defaultBrandCode + ',';
            this.defaultBrandCate = this.brandCateList.filter(items => {
              return str.indexOf(',' + items.brandCode + ',') !== -1;
            });
          }
        },
        // 接口失败
        afterError: () => {
          this.$loading.hide();
        }
      });
    },
    filterBrand(array) {
      let result = {};
      array.forEach(item => {
        if (result[item.barndNameFull]) {
          result[item.barndNameFull] += ',' + item.brandCode;
        } else {
          result[item.barndNameFull] = item.brandCode;
        }
      });
      let s = [];
      for (let k in result) {
        s.push({ barndNameFull: k, brandCode: result[k] });
      }
      return s;
    }
  },
  mounted() {
    this.showScreeningContentWidth();
  },
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
$screening-content-position-left: $rem80;
$screening-content-button-container-height: $rem100;
.screening-box-container {
  width: 100%;
  height: 100%;
  .screening-mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    opacity: 0.5;
    background: #000000;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .component-screening-box {
    position: fixed;
    left: 100%;
    top: 0;
    width: 100%;
    height: 100%;
    z-index: 2000;
    background: #ffffff !important;
    &.swipe-left {
      transform: translate3d(-100%, 0, 0);
      transition: transform 0.5s ease-out;
    }

    &.swipe-right {
      transform: translate3d(0, 0, 0);
      transition: transform 0.5s ease-out;
    }
    .content-container {
      width: 100%;
      height: 100%;
      position: absolute;
      overflow: hidden !important;
      background: #ffffff;
      .screening-content {
        padding-top: $rem20;
        padding-bottom: $screening-content-button-container-height;
        //position: absolute;
        //left: $screening-content-position-left;
        //top: 0;
        width: 100%;
        // height: 100%;
        z-index: 2001;
        background: #ffffff;
        // overflow-y: auto;
        // overflow-scrolling: touch;
        // -webkit-overflow-scrolling: touch;
      }
    }

    .screening-content-button-container {
      position: absolute;
      bottom: 0px !important;
      //left: $screening-content-position-left;
      left: 0;
      z-index: 2001 !important;
      width: 100%;
      height: $screening-content-button-container-height;
      display: flex;
      flex-direction: row;
      .screening-content-button {
        height: 100%;
        line-height: $screening-content-button-container-height;
        flex: 1;
        text-align: center;
        font-family: PingFangSC-Medium;
        font-size: $rem34;
        text-align: center;
      }
      .screening-content-reset {
        background: #ffffff;
        color: #666666;
      }
      .screening-content-sure {
        background: #d2a35f;
        color: #ffffff;
      }
    }

    .jr-x-fixed-bottom-bar {
      padding-bottom: constant(safe-area-inset-bottom) !important;
      padding-bottom: env(safe-area-inset-bottom) !important;
    }
    .jr-x-fixed-bottom-bar-inner {
      bottom: constant(safe-area-inset-bottom) !important;
      bottom: env(safe-area-inset-bottom) !important;
    }
    .jr-x-fixed-bottom-bar-inner:after {
      position: absolute;
      content: '';
      left: 0;
      //top: $screening-content-button-container-height!important;
      top: 100% !important;
      height: constant(safe-area-inset-bottom) !important;
      height: env(safe-area-inset-bottom) !important;
      width: 100%;
      z-index: 90;
      background-color: #fff;
    }
    .div-none {
      visibility: hidden;
      width: $screening-content-position-left;
    }
  }
}

.android {
  .screening-box-container {
    .component-screening-box {
      .content-container {
        .screening-content {
          padding-bottom: 300px;
        }
      }
    }
  }
}
</style>
